export default __webpack_public_path__ + "static/media/check.1d3a1d0c.svg";